import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HeadTitle = styled(Typography)`
  margin: 16px 0;
  text-align: center;
  width: 100%;
`;
export { HeadTitle };
